import { AvailabilitySearchResultsSimple } from 'components/www/availability-search/AvailabilitySearchResultsSimple';
import { ClassNames, useTheme } from '@emotion/react';
import { SearchHeader } from 'components/www/availability-search/SearchHeader';
import { SearchNavigation } from 'components/search/SearchNavigation';
import { availabilitySearchResultsHeight } from 'components/www/availability-search/searchResultsCssDefs';
import { useIsMediumScreen } from 'hooks/search/useIsBreakpointScreen';
import { useSearchDialogManager } from './useSearchDialogManager';
import { useSearchHandlerContext } from 'components/search/SearchContext';
import { useSearchRequestInProgress } from 'hooks/search/useSearchRequestInProgress';
import AvailabilitySearchMap from 'components/www/availability-search/AvailabilitySearchMap';
import AvailabilitySearchResultsFullMap from 'components/www/availability-search/AvailabilitySearchResultsFullMap';
import FloatingMapButton from 'components/www/availability-search/FloatingMapButton';
import PageContent from 'components/ui/PageContent';
import React, { FunctionComponent } from 'react';
import SearchExperienceMenuModal from 'components/www/availability-search/SearchExperienceMenuModal';
import SearchExperienceModal from 'components/www/availability-search/SearchExperienceModal';

/**
 * main layout of the search results page
 */
export const SearchResultsPage: FunctionComponent = () => {
  const { isFullMapView, openFullMapView, availability } = { ...useSearchHandlerContext() };
  const isPageLoading = useSearchRequestInProgress();
  const isMediumScreen = useIsMediumScreen();
  useSearchDialogManager();

  const theme = useTheme();

  const wrapBody = (content: React.ReactNode) => {
    return (
      <PageContent className="PageContent--page-search-results" animateRouteTransition={false}>
        {content}
      </PageContent>
    );
  };

  return wrapBody(
    <>
      <SearchNavigation />
      <AvailabilitySearchResultsFullMap />
      {!isFullMapView ? (
        <>
          <SearchHeader />
          <div className="AvailabilitySearchLayout">
            <ClassNames>
              {({ css }) => (
                <div
                  className={`AvailabilitySearchResults ${css(
                    availabilitySearchResultsHeight(theme, true)
                  )}`}
                >
                  <div className="AvailabilitySearchResults-map-results">
                    <div className="AvailabilitySearchResults-list AvailabilitySearchResults-list-ConsumerMobileMapSearch">
                      <AvailabilitySearchResultsSimple />
                    </div>
                  </div>
                  {openFullMapView && !isPageLoading && (availability?.result?.count ?? 0) > 0 ? (
                    <FloatingMapButton onClick={openFullMapView} />
                  ) : null}
                </div>
              )}
            </ClassNames>
            {/* on large screens we move the map in to it's own column */}
            {!isMediumScreen ? (
              <div className="AvailabilitySearch-map">
                <AvailabilitySearchMap />
              </div>
            ) : null}
          </div>
        </>
      ) : null}
      <SearchExperienceModal />
      <SearchExperienceMenuModal />
    </>
  );
};
